export const environment = {
  production: true,
  base_url:'https://new-api.mesbro.com/',
  IMAGE_URL: "https://s3.ap-south-1.amazonaws.com/files.mesbro.com/",

};
